import request from "../utils/request";
// 用户协议
export function agreemen(params) {
  return request({
    url: "/app/common/agreemen/queryById",
    method: "GET",
    params
  });
}
// 企业协议
export function agree(params) {
  return request({
    url: "/app/common/queryById",
    method: "GET",
    params
  });
}
// banner
export function banner(params) {
  return request({
    url: "/app/price/home/bannerList",
    method: "GET",
    params
  });
}
// 注册-属性列表
export function propertyList() {
  return request({
    url: "/app/common/propertyList",
    method: "GET",
  });
}

 // 注册-行业
export function industryList(params) {
  return request({
    url: "/app/common/industryList",
    method: "GET",
    params
  });
}
export function regionList(params) {
  return request({
    url: "/app/common/regionList", 
    method: "GET",
    params
  });
}
export function reg(data) {
  return request({
    url: "/app/login/register", 
    method: "POST",
    data
  });
}
//登录
export function login(data) {
  return request({
    url: "/app/login/login", 
    method: "POST",
    data
  });
} 
//修改密码
export function Changepassword(data) {
  return request({
    url: "/app/login/password",
    method: "PUT",
    data
  });
} 
//注销账户
export function deleteaccount(params) {
  return request({
    url: "/app/login/delete",
    method: "DELETE",
    params
  });
} 
//home
export function home() {
  return request({
    url: "/app/server/home",
    method: "GET",
  });
}
//token
export function token() {
  return request({
    url: "/app/login/token",
    method: "GET",
  });
}

//圈子-获取圈子列表
export function getpropertylist(params) {
  return request({
    url: "/app/property/list",
    method: "GET",
    params
  });
}
//圈子-获取通知
export function getLatestOne() {
  return request({
    url: "/app/news/getLatestOne",
    method: "GET",
  });
}
//圈子-申请访问
export function joinProperty(data) {
  return request({
    url: "/app/user/joinProperty",
    method: "POST",
    data
  });
} 

//圈友-获取圈子
export function userPropertyList(params) {
  return request({
    url: "/app/common/userPropertyList",
    method: "GET",
    params
  });
}
//圈友-获取圈友
export function listPropertyUser(params) {
  return request({
    url: "/app/user/listPropertyUser",
    method: "GET",
    params
  });
}
//圈友-获取好友
export function listFriend(params) {
  return request({
    url: "/app/user/listFriend",
    method: "GET",
    params
  });
}
//圈友-获取好友记录
export function listMyFriendRecord(params) {
  return request({
    url: "/app/user/listMyFriendRecord",
    method: "GET",
    params
  });
}
//圈友-新朋友
export function listFriendWaiting(params) {
  return request({
    url: "/app/user/listFriendWaiting",
    method: "GET",
    params
  });
}
//圈友-关注
export function isCollect(params) {
  return request({
    url: "/app/user/isCollect",
    method: "GET",
    params
  });
}
//圈友-是否好友
export function isFriend(params) {
  return request({
    url: "/app/user/isFriend",
    method: "GET",
    params
  });
}
//圈友-拒绝好友
export function rejectFriend(data) {
  return request({
    url: "/app/user/rejectFriend",
    method: "POST",
    data
  });
}
//圈友-同意好友
export function acceptFriend(data) {
  return request({
    url: "/app/user/acceptFriend",
    method: "POST",
    data
  });
}
//圈友-更新分组
export function updateFriend(data) {
  return request({
    url: "/app/user/updateFriend",
    method: "POST",
    data
  });
}
//圈友-圈友消息提示
export function chatRecordServercountall(params) {
  return request({
    url: "/app/chatRecordServer/countAll",
    method: "GET",
    params
  });
}
//圈友-圈友消息提示
export function countFriendWaiting(params) {
  return request({
    url: "/app/user/countFriendWaiting",
    method: "GET",
    params
  });
}
//聊天记录计算
export function chatRecordPropertycount(params) {
  return request({
    url: "/app/chatRecordProperty/count",
    method: "GET",
    params
  });
}
//聊天记录显示
export function chatRecordlist(params) {
  return request({
    url: "/app/chatRecordProperty/list",
    method: "GET",
    params
  });
}
//我的关注
export function listMyCollect(params) {
  return request({
    url: "/app/chatRecordProperty/listMyCollect",
    method: "GET",
    params
  });
}
//聊天发送图片/文件
export function addchat(data) {
  return request({
    url: "/app/chatRecordProperty/add",
    method: "POST",
    data
  });
}
//聊天装载表情包
export function emojisList() {
  return request({
    url: "/app/common/emojisList",
    method: "GET",
  });
}
//通知列表
export function newslist(params) {
  return request({
    url: "/app/news/list",
    method: "GET",
    params
  });
}
//通知-详情
export function newsdetail(params) {
  return request({
    url: "/app/news/detail",
    method: "GET",
    params
  });
}
//通知-客服
export function chatRecordServer(params) {
  return request({
    url: "/app/chatRecordServer/list",
    method: "GET",
    params
  });
}
//通知-私聊/客服
export function addchatRecordServer(data) {
  return request({
    url: "/app/chatRecordServer/add",
    method: "POST",
    data
  });
}
//动态-新增动态
export function addTrends(data) {
  return request({
    url: "/app/user/addTrends",
    method: "POST",
    data
  });
} 
//动态-装载动态
export function listTrends(params) {
  return request({
    url: "/app/user/listTrends",
    method: "GET",
    params,
  });
}
//动态-新增评论
export function comment(data) {
  return request({
    url: "/app/user/trends/comment",
    method: "POST",
    data
  });
} 
//企业查询-增加搜索历史
export function addSearchHistory(data) {
  return request({
    url: "/app/user/addSearchHistory", 
    method: "POST",
    data
  });
} 
//企业列表-罗列搜索记录
export function listSearchHistory(params) {
  return request({
    url: "/app/user/listSearchHistory",
    method: "GET",
    params,
  });
}
//企业列表-删除搜索记录
export function deleteSearchHistory(params) {
  return request({
    url: "/app/user/deleteSearchHistory",
    method: "POST",
    params,
  });
}
//企业列表
export function userCompanyList(params) {
  return request({
    url: "/app/company/userCompanyList",
    method: "GET",
    params,
  });
}
//报关/拖车询价-大区列表
export function askregionList() {
  return request({
    url: "/app/common/ask/regionList",
    method: "GET",
  });
}
//报关询价-品类列表
export function skuList() {
  return request({
    url: "/app/common/sku/list",
    method: "GET",
  });
}
//报关询价-查询
export function price(data) {
  return request({
    url: "/app/price/sku/price",
    method: "POST",
    data
  });
}
//报关询价-私聊
export function customer_report(params) {
  return request({
    url: "/app/server/by/customer",
    method: "GET",
    params
  });
}
//拖车询价-港区
export function ortAreaList(params) {
  return request({
    url: "/app/common/ask/ortAreaList",
    method: "GET",
    params
  });
}
//拖车询价-还提箱点
export function boxSiteList(params) {
  return request({
    url: "/app/common/ask/boxSite",
    method: "GET",
    params
  });
}
//拖车询价-装卸门点
export function provinceList(params) {
  return request({
    url: "/app/common/provinceCityDistrictTownship",
    method: "GET",
    params
  });
}
//拖车询价-查询1
export function pricecar1(params) {
  return request({
    url: "/app/price/car/price",
    method: "GET",
    params
  });
}
//拖车询价-查询2
export function pricecar2(params) {
  return request({
    url: "/app/price/queryById",
    method: "GET",
    params
  });
}
//拖车询价-私聊
export function customer_car(params) {
  return request({
    url: "/app/server/customer",
    method: "GET",
    params
  });
}
//个人主页-信息
export function queryById(params) {
  return request({
    url: "/app/user/queryById",
    method: "GET",
    params
  });
}
//个人主页-个性签名
export function updatePersonSign(data) {
  return request({
    url: "/app/user/updatePersonSign",
    method: "POST",
    data
  });
}
//个人主页-更新昵称
export function updateMininame(data) {
  return request({
    url: "/app/user/updateMininame",
    method: "POST",
    data
  });
}

//个人主页-手机号
export function updatePhoneState(data) {
  return request({
    url: "/app/user/updatePhoneState",
    method: "POST",
    data
  });
}
//个人主页-好友权限
export function updateFriendsState(data) {
  return request({
    url: "/app/user/updateFriendsState",
    method: "POST",
    data
  });
}
//个人主页-我的投诉
export function outComplaint(params) {
  return request({
    url: "/app/user/complaint/outComplaint",
    method: "GET",
    params
  });
}
//个人主页-被投诉
export function inComplaint(params) {
  return request({
    url: "/app/user/complaint/inComplaint",
    method: "GET",
    params
  });
}
//个人主页-投诉详情
export function detailComplaint(params) {
  return request({
    url: "/app/user/complaint/detail",
    method: "GET",
    params
  });
}
//个人主页-上传头像
export function upload(data) {
  return request({
    url: "/sys/common/upload",
    method: "POST",
    data
  });
}
//个人主页-更新头像
export function updatePersonPic(data) {
  return request({
    url: "/app/user/updatePersonPic",
    method: "POST",
    data
  });
}
//个人主页-实名认证
export function realVerify(data) {
  return request({
    url: "/app/user/realVerify",
    method: "POST",
    data
  });
}
//个人主页-企业认证
export function companyVerify(data) {
  return request({
    url: "/app/user/companyVerify",
    method: "POST",
    data
  });
}
//个人主页-企业认证
export function companylike(params) {
  return request({
    url: "/sys/common/static//test.docx",
    method: "GET",
    params
  });
}
//他人主页-提交投诉
export function complaintadd(data) {
  return request({
    url: "/app/user/complaint/add",
    method: "POST",
    data
  });
}
//他人主页-增加关注
export function addCollect(data) {
  return request({
    url: "/app/user/addCollect",
    method: "POST",
    data
  });
}
//他人主页-取消关注
export function cancelCollect(data) {
  return request({
    url: "/app/user/cancelCollect",
    method: "POST",
    data
  });
}
//他人主页-增加好友
export function addFriend(data) {
  return request({
    url: "/app/user/addFriend",
    method: "POST",
    data
  });
}
//他人主页-删除好友
export function deleteFriend(data) {
  return request({
    url: "/app/user/deleteFriend",
    method: "POST",
    data
  });
}
//他人主页-好友分组显示
export function grouplist(params) {
  return request({
    url: "/app/user/group/list",
    method: "GET",
    params
  });
}
//他人主页-新增分组
export function addgroup(data) {
  return request({
    url: "/app/user/group/add",
    method: "POST",
    data
  });
}


// WEBPACK FOOTER //
// ./src/api/api.js